import { removeConnections } from 'store/connections/sagaActions';
import { removeUnits } from './sagaActions';
import type { UnitInterface } from './types';

type DeleteUnitAction =
  ReturnType<typeof removeUnits> | ReturnType<typeof removeConnections>;

type DeleteUnitDispatch = (action: DeleteUnitAction) => void;

type DeleteUnitData = {
  key?: unknown;
  unitKey?: unknown;
  isPanel?: unknown;
};

const toKey = (key: unknown) =>
  typeof key === 'undefined' || key === null ? null : key.toString();

export const getDeleteUnitKeyFromData = (data: DeleteUnitData | null) => {
  if (!data) {
    return null;
  }

  if (data.isPanel) {
    return toKey(data.unitKey);
  }

  return toKey(data.key);
};

export const getDeleteUnitKeysFromData = (data: DeleteUnitData[]) => [
  ...new Set(
    data
      .map(getDeleteUnitKeyFromData)
      .filter((key): key is string => typeof key === 'string'),
  ),
];

export const filterExistingUnitKeys = (
  keys: string[],
  units: UnitInterface[],
) => {
  const existingUnitKeys = new Set(units.map((unit) => unit.key));

  return [...new Set(keys)].filter((key) => existingUnitKeys.has(key));
};

export const getDeleteUnitActions = (keys: string[]) => {
  const unitKeys = [...new Set(keys)];

  if (unitKeys.length === 0) {
    return [];
  }

  return [
    removeUnits(unitKeys),
    ...unitKeys.map((key) => removeConnections(key)),
  ];
};

export const dispatchDeleteUnits = (
  dispatch: DeleteUnitDispatch,
  keys: string[],
) => {
  getDeleteUnitActions(keys).forEach(dispatch);
};
